import React, { useState, useEffect } from 'react';
import rsilogo from '../Assets/logo.svg'
import seglogo from '../Assets/seg-logo.png'
import config from '../../Context/Config'

function FormHeader({ pageTitle }) {
    const [logoSrc, setLogoSrc] = useState("");;
        useEffect(() => {
            // Retrieve the item from localStorage
            const storedLogo = config.practice;
    
            // Check the value and set the logo accordingly
            if (storedLogo === "rsi") {
                setLogoSrc(rsilogo);
            } else {
                setLogoSrc(seglogo);
            }
        }, []);
    return (
        <header className="mx-5 bg-white/60 flex items-center justify-between">
            <img
                src={logoSrc}
                alt="Logo"
                className="w-20 h-auto pointer-events-none"
            />
            <h1 className="text-xl font-semibold text-sky-600 flex-grow text-center font-['Roboto']" id="header">
                {pageTitle}
            </h1>

        </header>

    );
}

export default FormHeader;
